import { CSSProperties } from 'react';
import { ClipLoader } from 'react-spinners';

type Props = {
  color: string;
  loading: boolean;
  size?: number;
  cssOverride?: CSSProperties;
};

const Spinner = ({ size = 100, ...props }: Props) => {
  return (
    <ClipLoader
      aria-label="Loading Spinner"
      data-testid="loader"
      size={size}
      {...props}
    />
  );
};

export default Spinner;
